import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-toggle',
    styleUrl: './toggle.component.scss',
    templateUrl: './toggle.component.html',
})
export class ToggleComponent {
    public readonly checked = input<boolean>(false);
    public readonly disabled = input<boolean>(false);
    public readonly disabledTooltip = input<string | undefined>(undefined);
    public readonly toggled = output<boolean>();

    protected onToggleChange(): void {
        if (this.disabled()) {
            return;
        }

        const nextValue = !this.checked();
        this.toggled.emit(nextValue);
    }
}
